module.exports = __webpack_public_path__ + "img/2bb86b2.png";